import * as React from 'react'
import { ReactElement } from 'react'
import { LineItemProps } from './LineItem'
import { Stack, Text } from '@fluentui/react'
import { Badge } from '@fluentui/react-components'
import { DataBarVerticalAscendingRegular, MoneyRegular } from '@fluentui/react-icons'
import { SurchargeListItemDto } from '../../../../../config/finance/financeConfig'
import useSurchargeType from '../../../../../hooks/useSurchargeType'
import MoneyText from '../../../../Text/Currency/MoneyText'
import { SurchargeValueType } from '../../../../../config/i18nConfig'

export default function SurchargeLineItem({ entity }: LineItemProps<SurchargeListItemDto>): ReactElement {
    const { surchargeType } = useSurchargeType(entity.surchargeType)

    return (
        <Stack horizontal={false} verticalAlign="center" tokens={{ childrenGap: 's2 s1', padding: 's2 0' }} wrap>
            <Text>{entity.name}</Text>
            <Stack horizontal tokens={{ childrenGap: 's2' }}>
                {surchargeType?.valueType === SurchargeValueType.Percentage && (
                    <Badge size="medium" icon={<DataBarVerticalAscendingRegular />} appearance="tint">
                        {entity.value || 0}
                        <small> %</small>
                    </Badge>
                )}
                {surchargeType?.valueType === SurchargeValueType.Fixed && (
                    <Badge size="medium" icon={<MoneyRegular />} appearance="tint">
                        <MoneyText currency={surchargeType.currency} amount={entity.value} textProps={{ size: 200 }} />
                    </Badge>
                )}
            </Stack>
        </Stack>
    )
}
